export default __webpack_public_path__ + "static/media/Ballroll_00277.63fe8687.png";